import { BLOCKS } from '@contentful/rich-text-types'
import { withDisplayName } from '@hocs/with-display-name'
import { paragraph } from '@render-node/paragraph'
import { documentHeading1 } from '@render-node/refresh-document-heading-1'
import { children } from '@render-node/utils/children'
import RichText from '@resolvers/rich-text'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const ContentfulPageImageTitlePodcastHero: Utils.EntryFC<
  Queries.ContentfulPageImageTitlePodcastFragment
> = ({
  content: { headline, subHeadline },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const { heroPodcastBackground } =
    useStaticQuery<Queries.HeroPodcastBackgroundQuery>(graphql`
      query HeroPodcastBackground {
        heroPodcastBackground: contentfulAsset(
          contentful_id: { eq: "1uLInFpFyyjaqWV9SUVT5t" }
          metadata: {
            tags: { elemMatch: { contentful_id: { eq: "scopeWebsite" } } }
          }
        ) {
          ...ContentfulDefaultAsset
        }
      }
    `)

  return (
    <div
      className="relative max-h-[430px] text-center"
      {...entryInspectorProps()}
    >
      <GatsbyImage
        alt={heroPodcastBackground.description}
        className="min-h-[200px] !w-full"
        image={getImage(heroPodcastBackground)}
        imgClassName="min-h-[200px]"
        objectFit="cover"
      />
      <div className="absolute inset-0 mx-auto flex max-w-3xl flex-col items-center justify-center px-4 text-white-50">
        <RichText
          className="mb-4 *:!mb-0 *:!text-230 *:!font-medium laptop:mb-8 *:laptop:!text-[56px]"
          {...fieldInspectorProps({
            fieldId: 'headline',
          })}
          content={headline}
          options={{
            renderNode: {
              [BLOCKS.DOCUMENT]: documentHeading1,
              [BLOCKS.PARAGRAPH]: children,
            },
          }}
        />
        {subHeadline && (
          <RichText
            className="*:!text-[18px]/[24px] *:!font-normal"
            {...fieldInspectorProps({
              fieldId: 'subHeadline',
            })}
            content={subHeadline}
            options={{
              renderNode: {
                [BLOCKS.PARAGRAPH]: paragraph,
              },
            }}
          />
        )}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageImageTitlePodcast on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    headline {
      text
    }
    subHeadline {
      text
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitlePodcastHero,
  'ContentfulPageImageTitlePodcastHero'
)
